const __WEBPACK_NAMESPACE_OBJECT__ = require("@toruslabs/http-helpers");